
import type { PropOptions } from 'vue';
import Vue from 'vue';
import BravadoPillV2 from '@/components/common/BravadoPillV2/BravadoPillV2.vue';

interface IOption {
  id: string;
  name: string;
  emoji: string;
}

export default Vue.extend({
  name: 'BravadoInlineCheckbox',
  components: {
    BravadoPillV2,
  },
  model: {
    prop: 'selectedItems',
    event: 'change',
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    } as PropOptions<Array<IOption>>,
    selectedItems: {
      type: Array,
      default: () => [],
    } as PropOptions<Array<number | string>>,
    multiple: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
    labelVariant: {
      type: String,
      default: 'body-semibold',
    } as PropOptions<string>,
    pillVariant: {
      type: String,
      default: 'border',
    } as PropOptions<string>,
  },
  computed: {
    selected(): Record<string, string | number> {
      return this.selectedItems.reduce((acc: Record<string, string | number>, val: string | number) => {
        acc[val] = val;
        return acc;
      }, {});
    },
  },
  methods: {
    handleSelect(val: IOption): void {
      const isActive = !this.selected[val.id];

      const selectedItemsObj = Object.assign({}, this.selected);
      selectedItemsObj[val.id] = isActive ? val.id : '';

      const selectedItemsArray = Object.values(selectedItemsObj).filter(val => val !== '');

      this.$emit('change', selectedItemsArray);
    },
  },
});
